module.exports = __webpack_public_path__ + "assets/img/sea2.b40b7260.png";